/*
 * BHS Announcement Bar
 * Countdown (Tage / Sekunden, Europe/Berlin), automatisches Ausblenden nach Ablauf, Rabattcode kopieren.
 * Vanilla JS, keine Abhängigkeiten. Eingebunden mit defer in sections/announcement-bar.liquid.
 */
(function () {
  'use strict';

  if (window.BHSAnnouncementBar) return;

  var DAY_MS = 86400000;
  var COPY_FEEDBACK_MS = 1600;
  var MAX_TIMEOUT = 2147483647;

  var berlinFormat = null;
  try {
    berlinFormat = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    });
  } catch (e) {
    berlinFormat = null;
  }

  // Kalendertag in Europe/Berlin als fortlaufende Tageszahl (unabhängig von der Browser-Zeitzone)
  function berlinDayIndex(ts) {
    var y, m, d;

    if (berlinFormat && berlinFormat.formatToParts) {
      var parts = berlinFormat.formatToParts(new Date(ts));
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'year') y = parseInt(parts[i].value, 10);
        if (parts[i].type === 'month') m = parseInt(parts[i].value, 10);
        if (parts[i].type === 'day') d = parseInt(parts[i].value, 10);
      }
    }

    if (!y || !m || !d) {
      // Fallback ohne Intl: MEZ (+1 h) annähern
      var f = new Date(ts + 3600000);
      y = f.getUTCFullYear();
      m = f.getUTCMonth() + 1;
      d = f.getUTCDate();
    }

    return Math.round(Date.UTC(y, m - 1, d) / DAY_MS);
  }

  function dateStringIndex(str) {
    var p = String(str || '').split('-');
    if (p.length < 3) return NaN;
    return Math.round(Date.UTC(parseInt(p[0], 10), parseInt(p[1], 10) - 1, parseInt(p[2], 10)) / DAY_MS);
  }

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function legacyCopy(text) {
    var active = document.activeElement;
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.select();

    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (e) {
      ok = false;
    }

    document.body.removeChild(ta);
    if (active && active.focus) {
      try {
        active.focus({ preventScroll: true });
      } catch (e) {}
    }

    if (!ok) throw new Error('copy failed');
  }

  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).catch(function () {
        legacyCopy(text);
      });
    }

    return new Promise(function (resolve) {
      legacyCopy(text);
      resolve();
    });
  }

  function Bar(root) {
    this.root = root;
    this.endTs = parseInt(root.getAttribute('data-end'), 10) * 1000;
    this.endIdx = dateStringIndex(root.getAttribute('data-end-date'));
    this.mode = root.getAttribute('data-mode') === 'seconds' ? 'seconds' : 'days';
    this.code = root.getAttribute('data-code') || '';
    this.texts = {
      today: root.getAttribute('data-text-today') || 'nur noch heute',
      tomorrow: root.getAttribute('data-text-tomorrow') || 'endet morgen',
      days: root.getAttribute('data-text-days') || 'noch [n] Tage'
    };

    this.promo = root.querySelector('[data-bhs-ab-promo]');
    this.fallback = root.querySelector('[data-bhs-ab-default]');
    this.status = root.querySelector('[data-bhs-ab-status]');
    this.daysEl = root.querySelector('[data-bhs-ab-days]');
    this.units = {
      d: root.querySelector('[data-bhs-ab-unit="d"]'),
      h: root.querySelector('[data-bhs-ab-unit="h"]'),
      m: root.querySelector('[data-bhs-ab-unit="m"]'),
      s: root.querySelector('[data-bhs-ab-unit="s"]')
    };

    this.interval = null;
    this.endTimeout = null;
    this.copyTimeout = null;

    this.onClick = this.onClick.bind(this);
    this.onVisibility = this.onVisibility.bind(this);

    root.addEventListener('click', this.onClick);

    if (this.promo) {
      if (!this.endTs) {
        this.expire();
        return;
      }
      document.addEventListener('visibilitychange', this.onVisibility);
      this.start();
    }
  }

  Bar.prototype.start = function () {
    var self = this;
    this.stop();

    if (!this.tick()) return;

    this.interval = setInterval(function () {
      self.tick();
    }, this.mode === 'seconds' ? 1000 : 60000);

    // Exakt zur Endzeit ausblenden (auch im Tage-Modus mit Minutentakt)
    var left = this.endTs - Date.now();
    if (left < MAX_TIMEOUT) {
      this.endTimeout = setTimeout(function () {
        self.tick();
      }, left + 50);
    }
  };

  Bar.prototype.stop = function () {
    if (this.interval) clearInterval(this.interval);
    if (this.endTimeout) clearTimeout(this.endTimeout);
    this.interval = null;
    this.endTimeout = null;
  };

  // Gibt false zurück, wenn die Aktion abgelaufen ist
  Bar.prototype.tick = function () {
    var now = Date.now();

    if (now >= this.endTs) {
      this.expire();
      return false;
    }

    if (this.mode === 'seconds') {
      var rest = Math.floor((this.endTs - now) / 1000);
      setText(this.units.d, pad(Math.floor(rest / 86400)));
      setText(this.units.h, pad(Math.floor((rest % 86400) / 3600)));
      setText(this.units.m, pad(Math.floor((rest % 3600) / 60)));
      setText(this.units.s, pad(rest % 60));
    } else if (this.daysEl) {
      var diff = this.endIdx - berlinDayIndex(now);
      var text;
      if (isNaN(diff) || diff <= 0) {
        text = this.texts.today;
      } else if (diff === 1) {
        text = this.texts.tomorrow;
      } else {
        text = this.texts.days.replace('[n]', diff);
      }
      setText(this.daysEl, text);
    }

    return true;
  };

  Bar.prototype.expire = function () {
    this.stop();
    document.removeEventListener('visibilitychange', this.onVisibility);

    if (this.promo) this.promo.hidden = true;
    if (this.fallback) this.fallback.hidden = false;

    this.root.classList.remove('bhs-ab--has-promo');
    this.root.classList.add('bhs-ab--expired');
  };

  Bar.prototype.onVisibility = function () {
    if (document.hidden) {
      this.stop();
    } else {
      this.start();
    }
  };

  Bar.prototype.onClick = function (event) {
    var button = event.target.closest ? event.target.closest('[data-bhs-ab-copy]') : null;
    if (!button || !this.root.contains(button)) return;

    var self = this;
    var code = this.code || (button.textContent || '').trim();

    copyText(code)
      .then(function () {
        button.classList.add('is-copied');
        setText(self.status, 'Rabattcode ' + code + ' kopiert');

        if (self.copyTimeout) clearTimeout(self.copyTimeout);
        self.copyTimeout = setTimeout(function () {
          button.classList.remove('is-copied');
          setText(self.status, '');
        }, COPY_FEEDBACK_MS);
      })
      .catch(function () {
        // Kopieren nicht möglich: still ignorieren, Code bleibt sichtbar
      });
  };

  Bar.prototype.destroy = function () {
    this.stop();
    if (this.copyTimeout) clearTimeout(this.copyTimeout);
    document.removeEventListener('visibilitychange', this.onVisibility);
    this.root.removeEventListener('click', this.onClick);
    this.root.__bhsAb = null;
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-bhs-ab]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__bhsAb) roots[i].__bhsAb = new Bar(roots[i]);
    }
  }

  function destroy(scope) {
    var roots = (scope || document).querySelectorAll('[data-bhs-ab]');
    for (var i = 0; i < roots.length; i++) {
      if (roots[i].__bhsAb) roots[i].__bhsAb.destroy();
    }
  }

  // Theme-Editor: Section wird bei Änderungen neu gerendert
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  window.BHSAnnouncementBar = { init: init, destroy: destroy };
})();